import { getFromAPI, postToAPI, wrongParams } from "./authUtils";

const AUTH_API_URL = process.env.NEXT_PUBLIC_AUTH_API_URL;


export const checkApiEnv = () => !!AUTH_API_URL;

export const apiSignIn = async (params) => {
    /** Check required parameters and return errors if any...*/
    if (!params) return wrongParams("params");
    const { lang } = params;
    
    if (!checkApiEnv()) {
        return {
            ok: false,
            code: 503,
            message: lang === "pl" ? "API niedostępne" : "API unavailable",
        };
    }

    /** ...else request API */
    const URL = `${AUTH_API_URL}/api/login`;
    const DATA = await postToAPI(URL, params);


    return DATA;
};

export const apiSignSessionIn = async (params) => {
    /** Check required parameters and return errors if any...*/
    if (!params) return wrongParams("params");
    const { lang } = params;
    
    if (!checkApiEnv()) {
        return {
            ok: false,
            code: 503,
            message: lang === "pl" ? "API niedostępne" : "API unavailable",
        };
    }

    /** ...else request API */
    const URL = `${AUTH_API_URL}/api/sessionLogin`;
    const DATA = await postToAPI(URL, params);


    return DATA;
};

export const apiSignOut = async (params) => {

    /** Check required parameters and return errors if any...*/
    if (!params) return wrongParams("params");
    const { lang } = params;

    if (!checkApiEnv()) {
        return {
            ok: false,
            code: 503,
            message: lang === "pl" ? "API niedostępne" : "API unavailable",
        };
    }

    /** ...else request API */
    const URL = `${AUTH_API_URL}/api/logout`;
    const DATA = await postToAPI(URL, params);


    return DATA;
};

export const apiRegister = async (params) => {
    /** Check required parameters and return errors if any...*/
    if (!params) return wrongParams("params");
    const { lang } = params;

    if (!checkApiEnv()) {
        return {
            ok: false,
            code: 503,
            message: lang === "pl" ? "API niedostępne" : "API unavailable",
        };
    }

    /** ...else request API */
    const URL = `${AUTH_API_URL}/api/register`;
    const DATA = await postToAPI(URL, params);
    return DATA;
};

export const apiVerifyEmail = async (params) => {
    /** Check required parameters and return errors if any...*/
    if (!params) return wrongParams("params");
    const { lang } = params;

    if (!checkApiEnv()) {
        return {
            ok: false,
            code: 503,
            message: lang === "pl" ? "API niedostępne" : "API unavailable",
        };
    }

    /** ...else request API */
    const URL = `${AUTH_API_URL}/api/verifyEmail`;
    const DATA = await postToAPI(URL, params);
    return DATA;
};

export const apiResendEmailCode = async (params) => {
    /** Check required parameters and return errors if any...*/
    if (!params) return wrongParams("params");
    const { lang } = params;

    if (!checkApiEnv()) {
        return {
            ok: false,
            code: 503,
            message: lang === "pl" ? "API niedostępne" : "API unavailable",
        };
    }

    /** ...else request API */
    const URL = `${AUTH_API_URL}/api/resendEmailCode`;
    const DATA = await postToAPI(URL, params);
    return DATA;
};

export const refetchTokens = async (params) => {
    const URL = `${AUTH_API_URL}/api/refetchTokens`;
    const DATA = await postToAPI(URL, params);
    return DATA;
};
